import React from "react";
import { locales } from "../../locales";
import { getDataSource } from "../../services/api";
import CandidateImage from "./CandidateImage";

const Candidates = ({ data, langId, isDesktop }) => {
  const titlePadding = (role) => {
    if (role) {
      return { marginTop: "-4px" };
    } else {
      return { marginTop: "15px" };
    }
  };

  const boxStyle = (isDesktop) => {
    if (isDesktop) {
      return {
        marginBottom: "0px",
        minHeight: 125,
        backgroundColor: "#F4F4F4",
      };
    } else {
      return {
        marginBottom: "12px",
        minHeight: 125,
        backgroundColor: "#F4F4F4",
      };
    }
  };
  return (
    <div className="wort-small:grid wort-small:grid-cols-2 wort-small:gap-3 wort-medium:grid-cols-3">
      {data.map((item) => {
        return (
          <div
            className="px-2 pt-2.5 flex flex-row items-start rounded-md"
            style={boxStyle(isDesktop)}
            key={item.id}
          >
            <CandidateImage
              imageUrl={`${getDataSource()}/portraits/${item.imageWebp}`}
              imageUrlFallback={`${getDataSource()}/portraits/${item.image}`}
            />
            <div className="flex flex-col items-start w-full">
              <span className="font-bold leading-6" style={{ fontSize: 18 }}>
                {item.name}
              </span>
              <div style={titlePadding(item.function || item.nationalMandate)}>
                {item.function && (
                  <span className="text-xs mr-1">{item.function}</span>
                )}
                {item.function && item.nationalMandate && "|"}
                {item.nationalMandate && (
                  <span className="text-xs ml-1">{item.nationalMandate}</span>
                )}
              </div>
              <hr style={{ width: "100%" }} />
              <div className="h-4 mt-0.5">
                <span className="text-xs mr-2">{locales[langId].age}:</span>
                <span className="text-xs font-semibold">
                  {item.age ? item.age : locales[langId].noDataAvailable}
                </span>
              </div>
              <div className="h-4 mt-0.5">
                <span className="text-xs mr-2">
                  {locales[langId].firstMandate}:
                </span>
                <span className="text-xs font-semibold">
                  {item.firstMandate
                    ? item.firstMandate
                    : locales[langId].noDataAvailable}
                </span>
              </div>
              <div className="h-4 mt-1.5 flex flex-row">
                <span className="text-xs mr-2">
                  {locales[langId].occupation}:
                </span>
                <p
                  className="text-xs font-semibold"
                  style={{ lineHeight: "14px" }}
                >
                  {item.occupation
                    ? item.occupation
                    : locales[langId].noDataAvailable}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Candidates;
